"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterimScreenTitle = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importDefault(require("styled-components"));
function InterimScreenTitle({ children, className, fontFamily = 'elsevier', }) {
    return ((0, jsx_runtime_1.jsx)(Title, { className: className, "$fontFamily": fontFamily, "data-e2e": 'InterimScreenTitle_Title', children: children }));
}
exports.InterimScreenTitle = InterimScreenTitle;
const Title = styled_components_1.default.h1 `
  margin: 0;
  padding: 0;

  font-size: 20px;
  line-height: 23px;
  font-weight: 400;
  text-align: center;

  color: ${props => props.theme.white};

  font-family: ${({ $fontFamily }) => $fontFamily === 'elsevier' ? 'Elsevier Sans' : 'Main CA Font'};

  ${ui_1.device.laptopS `
    font-size: 30px;
    line-height: 34px;
  `}
`;
